function Tanzania({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2285)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#FFDA44"/>
  <path d="M4.68627 27.3138C5.35746 27.985 6.07358 28.5835 6.82477 29.1105L29.1104 6.82483C28.5835 6.07365 27.9849 5.35752 27.3137 4.68634C26.6425 4.01515 25.9264 3.41665 25.1752 2.88965L2.88965 25.1753C3.41652 25.9263 4.01515 26.6425 4.68627 27.3138Z" fill="black"/>
  <path d="M4.68624 4.68653C-0.361383 9.73428 -1.33045 17.315 1.77724 23.3364L23.3361 1.77759C17.3147 -1.33009 9.73393 -0.360968 4.68624 4.68653Z" fill="#6DA544"/>
  <path d="M27.3136 27.3139C32.3613 22.2663 33.3303 14.6855 30.2227 8.66406L8.66382 30.2229C14.6851 33.3306 22.266 32.3615 27.3136 27.3139Z" fill="#338AF3"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Tanzania;
